export default __webpack_public_path__ + "static/media/icon-sun.910b1f9a.svg";